/**
 * One-time page-session flag used by auth bootstrap/account selection flow.
 */
let pending = false;

export const markPendingAccountSelection = () => {
    pending = true;
};

export const consumePendingAccountSelection = (): boolean => {
    const wasPending = pending;
    pending = false;
    return wasPending;
};
